import o from"@emotion/styled";const e=o.div`
  label: bottomsheet;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 899;
  bottom: 0px;
  left: 0px;
  position: fixed;
  background-color: rgb(31 34 39 / 0.2);
  opacity: 0;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  ${t=>t.shouldRenderStyles&&{opacity:1}}
`,i=o.div`
  label: bottomsheet-wrapper;
  user-select: none;
  background-color: rgb(255 255 255);
  position: absolute;
  margin: 0 auto;
  overflow-y: auto;
  bottom: -100%;
  left: 0px;
  right: 0px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  z-index: 900;
  padding: 20px;
  max-width: 480px;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 300ms;
  ${t=>t.shouldRenderStyles&&{bottom:"0px"}}
`;export{e as BottomSheetStyled,i as BottomSheetWrapperStyled};
